export class FiltrosBusquedaVacante {
    id: string = '';
    idPuesto?: string;
    idUbicacion?: string;
    idFechaPublicacion?: string;
    idSalario?: string;
    job?: string;
    salario?: string;
    antiguedad?: string;

    constructor(data?: Partial<FiltrosBusquedaVacante>) {
        Object.assign(this, data);
    }
}